(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (document.querySelector('.v3-project')) return;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var themeMeta = document.querySelector('meta[name="theme-color"]');
  var scrollbar = document.querySelector('[data-inkd-scrollbar]');
  var thumb = document.querySelector('[data-inkd-scrollbar-thumb]');
  var darkSections = document.querySelectorAll('[data-v3-dark]');
  var hideTimer = 0;
  var dragging = false;
  var dragOffset = 0;
  var lenis = null;

  function maxScroll() {
    return Math.max(root.scrollHeight - window.innerHeight, 1);
  }

  function currentScroll() {
    if (lenis) return lenis.scroll;
    return window.scrollY || root.scrollTop || 0;
  }

  function currentProgress() {
    if (lenis) return lenis.progress;
    return currentScroll() / maxScroll();
  }

  function metrics() {
    var trackHeight = scrollbar ? scrollbar.clientHeight : window.innerHeight;
    var ratio = window.innerHeight / Math.max(root.scrollHeight, 1);
    var thumbHeight = Math.max(Math.min(ratio * trackHeight, trackHeight), 48);
    return {
      thumbHeight: thumbHeight,
      maxThumb: Math.max(trackHeight - thumbHeight, 1),
    };
  }

  function setTheme(onHero) {
    root.classList.toggle('inkd-on-hero', onHero);
    if (themeMeta) themeMeta.setAttribute('content', onHero ? '#1D293A' : '#F3F1E9');
  }

  // Same class-toggle pattern as the hero: flip inkd-on-dark on when the
  // thumb is physically over a navy/forest section. Instant, no transition.
  function overDarkSection() {
    if (!thumb) return false;
    var ty = thumb.getBoundingClientRect().top + thumb.offsetHeight / 2;
    for (var i = 0; i < darkSections.length; i++) {
      var r = darkSections[i].getBoundingClientRect();
      if (r.top <= ty && r.bottom >= ty) return true;
    }
    return false;
  }

  function render() {
    setTheme(currentScroll() < window.innerHeight * 0.72);
    if (!scrollbar || !thumb) return;

    if (root.scrollHeight <= window.innerHeight + 1) {
      scrollbar.hidden = true;
      return;
    }

    scrollbar.hidden = false;
    var size = metrics();
    var progress = Math.min(Math.max(currentProgress(), 0), 1);
    thumb.style.height = size.thumbHeight + 'px';
    thumb.style.transform = 'translate3d(0,' + progress * size.maxThumb + 'px,0)';
    root.classList.toggle('inkd-on-dark', overDarkSection());
  }

  function reveal() {
    if (!scrollbar || scrollbar.hidden) return;
    scrollbar.classList.add('is-visible');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      if (!dragging) scrollbar.classList.remove('is-visible');
    }, 900);
  }

  function onScroll() {
    render();
    reveal();
  }

  function scrollToY(top, immediate) {
    if (lenis) {
      lenis.scrollTo(top, { immediate: immediate });
      return;
    }
    window.scrollTo({ top: top, behavior: immediate ? 'auto' : 'smooth' });
  }

  if (!reduce && typeof Lenis === 'function') {
    lenis = new Lenis({
      autoRaf: false,
      autoToggle: true,
      anchors: true,
      allowNestedScroll: true,
      naiveDimensions: true,
      stopInertiaOnNavigate: true,
      lerp: 0.075,
      wheelMultiplier: 0.82,
      syncTouch: false,
    });
    window.lenis = lenis;
    lenis.on('scroll', onScroll);

    if (typeof gsap !== 'undefined') {
      if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        lenis.on('scroll', ScrollTrigger.update);
      }
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    } else {
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  window.addEventListener('resize', render);

  if (thumb && scrollbar) {
    thumb.addEventListener('pointerdown', function (event) {
      dragging = true;
      scrollbar.classList.add('is-dragging', 'is-visible');
      dragOffset = event.clientY - thumb.getBoundingClientRect().top;
      thumb.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    thumb.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var size = metrics();
      var y = event.clientY - scrollbar.getBoundingClientRect().top - dragOffset;
      y = Math.min(Math.max(y, 0), size.maxThumb);
      scrollToY((y / size.maxThumb) * maxScroll(), true);
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      scrollbar.classList.remove('is-dragging');
      reveal();
    }

    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    scrollbar.addEventListener('pointerdown', function (event) {
      if (event.target === thumb) return;
      var size = metrics();
      var y = event.clientY - scrollbar.getBoundingClientRect().top - size.thumbHeight / 2;
      y = Math.min(Math.max(y, 0), size.maxThumb);
      scrollToY((y / size.maxThumb) * maxScroll(), false);
    });
  }

  render();
})();
